window.addEventListener("turbolinks:load", () => {
    const element = document.querySelector("#appointment");
    if (element != null) {
      element.addEventListener("ajax:success", (event) => {
        const [_data, _status, xhr] = event.detail;
        $('#days-to-appointment').remove();
        $('#date_action').remove();
        $('#new-appointment').remove();
        element.innerHTML = xhr.responseText;
        document.dispatchEvent(new CustomEvent('appointment:content-updated'));
      });
      element.addEventListener("ajax:error", (event) => {
        const [_data, _status, xhr] = event.detail;
        alert(xhr.responseText)
      });
    }
  });
